import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import TitleBar from "../../components/TitleBar";
import { Button, Divider, Box } from "@mui/material";
import {
  dateTimeSavedToDisplay,
  getCurrentOpenTrip,
  getDisplayTripType,
} from "../../constants/vtrTrip";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import TripReviewNav from "../../components/TripReviewNav";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import EffortList from "../../components/EffortList";
import SalesList from "../../components/SalesList";
import Spinner from "../../components/common/Spinner";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { getNrEfforts } from "../../constants/Effort";
import DeleteTrip from "./DeleteTrip";
import { getFieldLabel } from "../../constants/Helpers";

function VtrTrip(props) {
  const { actions } = props;
  const [currentTrip, setCurrentTrip] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [isExisting, setIsExisting] = useState(false);
  const [noEffortReasonValue, setReasonValue] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { auth, vtrTrip, validation } = useSelector((state) => state);

  const styles = {
    button: {
      justifyContent: "space-between",
      color: "ButtonText",
    },
  };

  useEffect(() => {
    if (isLoaded === false) {
      actions.setTrip(auth.client_id);
      if (auth.redirect) {
        actions.resetTripRedirect();
      }
      const tripId = location.state.trip_id;
      const openTrip = getCurrentOpenTrip(vtrTrip.allOpenTrips, tripId);
      const effortReasons = validation.validations.activity;
      if (Object.keys(openTrip).length > 0) {
        setIsExisting(true);
        // * Assigned a default value to report_type in case of an old trip
        // * in the user's homepage.
        if (
          !openTrip.hasOwnProperty("report_type") ||
          (openTrip.hasOwnProperty("report_type") &&
            openTrip.report_type === "") ||
          (openTrip.hasOwnProperty("report_type") &&
            openTrip.report_type === null)
        ) {
          openTrip.report_type = "1";
        }

        setCurrentTrip(openTrip);

        if (openTrip.no_effort_trip_reason !== "" && effortReasons) {
          effortReasons.forEach((reason) => {
            if (reason.KEY === Number(openTrip.no_effort_trip_reason)) {
              setReasonValue(reason.VALUE);
              return;
            }
          });
        }
      }
      setIsLoaded(true);
    }
  }, [
    actions,
    auth.client_id,
    auth.redirect,
    isLoaded,
    location.state.trip_id,
    validation.validations,
    vtrTrip,
  ]);

  const _showConfirm = (event) => {
    event.preventDefault();
    setOpen(true);
  };

  const _deleteTrip = (event) => {
    event.preventDefault();
    actions.deleteTrip(event);
    navigate(`${process.env.PUBLIC_URL}/home`, {
      state: {
        client_id: auth.client_id,
        user_full_name: auth.user_full_name,
        redirect: false,
      },
    });
  };

  if (isLoaded === false) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  if (vtrTrip.redirect === true && isLoaded === true) {
    return (
      <Navigate
        replace
        to={`${process.env.PUBLIC_URL}/home`}
        state={{
          client_id: auth.client_id,
          user_full_name: auth.user_full_name,
        }}
      />
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justify="center"
      alignItems="center"
    >
      <Box width="100%">
        <TitleBar
          title="Trip Report"
          delete_button={isExisting === true ? _showConfirm : false}
          client_id={auth.client_id}
          trip_id={currentTrip.trip_id}
        />
      </Box>
      {open && (
        <DeleteTrip
          isVisible={open}
          setIsVisible={setOpen}
          client_id={auth.client_id}
          trip_id={currentTrip.trip_id}
          handleAction={_deleteTrip}
        />
      )}
      <Box justifyContent="center" alignItems="center" width="auto">
        <Box>
          <h3 align="center">{`Trip id: ${
            currentTrip.submission_type.toUpperCase() === "PAPER"
              ? currentTrip.lowest_serial_num
              : currentTrip.trip_id
          }`}</h3>
        </Box>
        <Divider />
        <Box>
          <h3 className="margLeft10">{"Trip Information:"}</h3>
          <Button
            fullWidth
            style={styles.button}
            endIcon={<NavigateNextIcon />}
          >
            {"Vessel: " +
              (currentTrip.vessel_permit_num
                ? currentTrip.vessel_permit_num +
                  " " +
                  currentTrip.vessel_registration +
                  " " +
                  currentTrip.vessel_name
                : "")}
          </Button>
        </Box>
        <Divider />
        <Box>
          <Link
            to={`${process.env.PUBLIC_URL}/trip-type`}
            state={{
              trip_id: currentTrip.trip_id,
            }}
            className="side-nav"
          >
            <Button
              fullWidth
              style={styles.button}
              endIcon={<NavigateNextIcon />}
            >
              {"Trip Type: " +
                getDisplayTripType(
                  currentTrip.report_type || "1",
                  currentTrip.trip_type,
                  validation.validations.reportTripType
                )}
            </Button>
          </Link>
        </Box>
        <Divider />
        <Box>
          <Link
            to={`${process.env.PUBLIC_URL}/operator-vessel`}
            state={{
              trip_id: currentTrip.trip_id,
            }}
            className="side-nav"
          >
            <Button
              fullWidth
              style={styles.button}
              endIcon={<NavigateNextIcon />}
            >
              {"Operator: " +
                (currentTrip.operator_permit_number
                  ? currentTrip.operator_first_name +
                    (currentTrip.operator_middle_name
                      ? " " + currentTrip.operator_middle_name
                      : "") +
                    " " +
                    currentTrip.operator_last_name +
                    (currentTrip.operator_ext_name
                      ? " " + currentTrip.operator_ext_name
                      : "")
                  : "")}
            </Button>
          </Link>
        </Box>
        <Divider />
        <Box>
          <Link
            to={`${process.env.PUBLIC_URL}/date-sail`}
            state={{
              trip_id: currentTrip.trip_id,
            }}
            className="side-nav"
          >
            <Button
              fullWidth
              style={styles.button}
              endIcon={<NavigateNextIcon />}
            >
              {"Date Time Sailed: " +
                (currentTrip.date_sail
                  ? dateTimeSavedToDisplay(currentTrip.date_sail)
                  : "")}
            </Button>
          </Link>
        </Box>
        <Divider />
        <Box>
          <Link
            to={`${process.env.PUBLIC_URL}/landing-date`}
            state={{
              trip_id: currentTrip.trip_id,
            }}
            className="side-nav"
          >
            <Button
              fullWidth
              style={styles.button}
              endIcon={<NavigateNextIcon />}
            >
              {"Date Time" +
                " Landed: " +
                (currentTrip.date_land
                  ? dateTimeSavedToDisplay(currentTrip.date_land)
                  : "")}
            </Button>
          </Link>
        </Box>
        <Divider />

        <Box>
          <Link
            to={`${process.env.PUBLIC_URL}/trip-type`}
            state={{
              trip_id: currentTrip.trip_id,
            }}
            className="side-nav"
          >
            <Button
              fullWidth
              style={styles.button}
              endIcon={<NavigateNextIcon />}
            >
              {"Number of Crew: " +
                (currentTrip.number_of_crew
                  ? currentTrip.number_of_crew
                  : "N/A")}
            </Button>
          </Link>
        </Box>
        <Divider />
        <Box>
          <Link
            to={`${process.env.PUBLIC_URL}/trip-type`}
            state={{
              trip_id: currentTrip.trip_id,
            }}
            className="side-nav"
          >
            <Button
              fullWidth
              style={styles.button}
              endIcon={<NavigateNextIcon />}
            >
              {"Number of Anglers: " +
                (currentTrip.number_of_anglers
                  ? currentTrip.number_of_anglers
                  : "N/A")}
            </Button>
          </Link>
        </Box>
        <Divider />
        {currentTrip.report_type === "2" &&
          currentTrip.no_effort_trip_reason === "0" && (
            <>
              <Box>
                <Link
                  to={`${process.env.PUBLIC_URL}/landing-date`}
                  state={{
                    trip_id: currentTrip.trip_id,
                  }}
                  className="side-nav"
                >
                  <Button
                    fullWidth
                    style={styles.button}
                    endIcon={<NavigateNextIcon />}
                  >
                    {getFieldLabel("trip", "trapsInWater") +
                      ": " +
                      (currentTrip.trapsInWater
                        ? currentTrip.trapsInWater
                        : "")}
                  </Button>
                </Link>
              </Box>
              <Divider />
              <Box>
                <Link
                  to={`${process.env.PUBLIC_URL}/landing-date`}
                  state={{
                    trip_id: currentTrip.trip_id,
                  }}
                  className="side-nav"
                >
                  <Button
                    fullWidth
                    style={styles.button}
                    endIcon={<NavigateNextIcon />}
                  >
                    {getFieldLabel("trip", "trapsPerString") +
                      ": " +
                      (currentTrip.trapsPerString
                        ? currentTrip.trapsPerString
                        : "")}
                  </Button>
                </Link>
              </Box>
              <Divider />
              <Box>
                <Link
                  to={`${process.env.PUBLIC_URL}/landing-date`}
                  state={{
                    trip_id: currentTrip.trip_id,
                  }}
                  className="side-nav"
                >
                  <Button
                    fullWidth
                    style={styles.button}
                    endIcon={<NavigateNextIcon />}
                  >
                    {getFieldLabel("trip", "totNrBuoyLines") +
                      ": " +
                      (currentTrip.buoyLines ? currentTrip.buoyLines : "")}
                  </Button>
                </Link>
              </Box>
              <Divider />
            </>
          )}
        {currentTrip.no_effort_trip_reason !== "0" && (
          <>
            <Box>
              <Link
                to={`${process.env.PUBLIC_URL}/no-effort`}
                state={{
                  client_id: auth.client_id,
                  trip_id: currentTrip.trip_id,
                }}
                className="side-nav"
              >
                <Button
                  fullWidth
                  style={styles.button}
                  endIcon={<NavigateNextIcon />}
                >
                  {"No Effort Trip Reason: " + noEffortReasonValue}
                </Button>
              </Link>
            </Box>
            <Divider />
          </>
        )}
        <Box>
          <h3 className="margLeft10">{"Efforts:"}</h3>
          <EffortList trip={currentTrip} client_id={auth.client_id} />
        </Box>
        <Box>
          <h3 className="margLeft10">{"Offload / Sale Details:"}</h3>
          <SalesList trip={currentTrip} client_id={auth.client_id} />
        </Box>

        <TripReviewNav
          vesselNbr={currentTrip.vessel_permit_num}
          trip_id={currentTrip.trip_id}
          currentTrip={currentTrip}
          client_id={auth.client_id}
          newEffortNr={getNrEfforts(currentTrip)}
          deleteTrip={isExisting === true ? _showConfirm : false}
        />
      </Box>
    </Box>
  );
}

export default connect(null, mapDispatchToProps)(VtrTrip);
